/**
 * @desc 查询月计划列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanMonthQueryRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanMonthResponse>>> {
  return defHttp.post({
    url: '/wap/plan/month/query',
    data,
  });
}

export function mock(
  data: defs.PlanMonthQueryRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanMonthResponse>>> {
  return defHttp.post({
    url: '/mock/wap/plan/month/query',
    data,
  });
}
